export default __webpack_public_path__ + "static/media/2019-plan-2.f770c000.jpeg";